const request = {}

request.createRequest = function (toStatus) {
  return {
    toStatus
  }
}
export default { request }
